import ScreenEntity from './screen.entity';

export default class MyAuthority {
  name: string;

  description: string;

  screens: ScreenEntity[];

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.screens = obj.screens || [];
  }
}
